/**
 * AndVHeatmap - 热力图组件
 * 基于 Ant Design Charts Heatmap
 */
import React from 'react';
import { Heatmap } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVHeatmapProps } from '../base/types';

const DEFAULT_HEATMAP_DATA = [
  { x: '周一', y: '上午', value: 12 },
  { x: '周一', y: '下午', value: 18 },
  { x: '周二', y: '上午', value: 15 },
  { x: '周二', y: '下午', value: 22 },
  { x: '周三', y: '上午', value: 9 },
  { x: '周三', y: '下午', value: 16 },
  { x: '周四', y: '上午', value: 20 },
  { x: '周四', y: '下午', value: 25 },
];

const HeatmapWithBase = withBaseChart<AndVHeatmapProps>(Heatmap, {
  chartType: 'AndVHeatmap',
  defaultHeight: 300,
  defaultData: DEFAULT_HEATMAP_DATA,
});

export const AndVHeatmap: React.FC<AndVHeatmapProps> = (props) => {
  const {
    xField = 'x',
    yField = 'y',
    colorField = 'value',
    sizeField,
    ...baseProps
  } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    xField,
    yField,
    colorField,
  };

  if (sizeField) chartProps.sizeField = sizeField;

  return <HeatmapWithBase {...chartProps} />;
};

export type { AndVHeatmapProps };
export default AndVHeatmap;
